import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import OETextEdit from '../../../elements/controls/oe-text-edit';
import OENoteStateProvider from './oe-note-state-provider';
import {CustomScrollbarTrackVisibility, CustomScrollbarProps} from '../../../../lib/custom-scrollbar/custom-scrollbar-model';

export default class OENoteTextEdit extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.id = typeof(this.props.id) === 'number' ? this.props.id : null;

        this.state = {
            noteState: OENoteStateProvider.defaultNoteState(),
            noteText: '',
            unitSize: 16
        };

        this.onNoteTextChanged = this.onNoteTextChanged.bind(this);

        this.onUnitSizeResize = this.onUnitSizeResize.bind(this);

        this.onNoteStateChanged = this.onNoteStateChanged.bind(this);

        this.onTextEditRef = this.onTextEditRef.bind(this);

        this.onTextEditChanged = this.onTextEditChanged.bind(this);
    }

    focus() {
        if(this.textEditRef)    this.textEditRef.focus();
    }

    scrollToEnd() {
        if(this.textEditRef)    this.textEditRef.scrollToEnd();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.id !== this.props.id)     {
            this.id = typeof(nextProps.id) === 'number' ? nextProps.id : null;
            this.updateNoteText();
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteTextChanged, this.onNoteTextChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteTextChanged, this.onNoteTextChanged);
    }

    updateNoteText(text)  {
        if((!this.oe.isReady() || this.id === null) && !text)    return;
        let text_ = text || this.oe.sharedInterface.getUIControllerNote().getNoteText(this.id);
        this.setState({noteText: OEToolbox.decode_utf8(text_)});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateNoteText();

        window.requestAnimationFrame(() => {
            if(this.textEditRef && this.props.autofocus)   {
                this.focus();
            }

            if(this.state.noteText && this.textEditRef && this.props.scrollToEnd)   {
                this.scrollToEnd();
            }
        });
    }

    onNoteTextChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteText(userInfo.text);
    }

    onNoteStateChanged(sender, noteState)   {
        this.setState({noteState: clone(noteState)});
    }

    onUnitSizeResize(sender, size)  {
        this.setState({unitSize: size.w});
    }

    onTextEditRef(ref)  {
        if(this.textEditRef === ref)    return;
        this.textEditRef = ref;

        if(this.textEditRef && this.props.autofocus)   {
            this.focus();
        }

        if(this.state.noteText && this.textEditRef && this.props.scrollToEnd)   {
            this.scrollToEnd();
        }
    }

    render()    {
        //const unitScale = this.state.unitSize ? this.state.unitSize / 16 : 1;
        const textEditFontSize = null; //unitScale * Math.min(32, this.state.noteState.style.fontSize);

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OENoteStateProvider moduleId={this.props.moduleId} id={this.props.id} onNoteStateChanged={this.onNoteStateChanged}/>

                {
                //<OEResizeObserver className="unit-size-observer" onResize={this.onUnitSizeResize}/>
                }

                <OETextEdit
                    singleLine={this.props.singleLine}
                    maxTextLength={this.props.maxTextLength}
                    fontSize={textEditFontSize}
                    value={this.state.noteText}
                    scrollbar={this.props.scrollbar}
                    onChange={this.onTextEditChanged}
                    onFocus={this.props.onFocus}
                    onBlur={this.props.onBlur}
                    onKeyDown={this.props.onKeyDown}
                    ref={this.onTextEditRef}
                />
            </React.Fragment>
        )
    }

    onTextEditChanged(sender, value)	{
        if(!this.oe.isReady() || this.id === null) {
            if(this.props.onChange) this.props.onChange(sender, value);
            return;
        }

        this.oe.sharedInterface.getUIControllerNote().setNoteTextExt(this.id, OEToolbox.encode_utf8(value), this.props.force);

        if(this.props.onChange) this.props.onChange(sender, value);
    }
}

OENoteTextEdit.defaultProps = {
    moduleId:                       '',
    singleLine:                     false,
    autofocus:                      false,
    scrollToEnd:                    false,
    scrollbar: {
        bare:                       true,               // without bare minSize for textarea element does not work for autosize=true path
        horizontalTrackVisiblity:   CustomScrollbarTrackVisibility.none,
        verticalTrackVisiblity:     CustomScrollbarTrackVisibility.always,
    },
    force:                          false
};

OENoteTextEdit.propTypes = {
    moduleId:                       PropTypes.string,
    singleLine:                     PropTypes.bool,
    autofocus:                      PropTypes.bool,
    scrollToEnd:                    PropTypes.bool,
    maxTextLength:                  PropTypes.number,
    scrollbar:                      CustomScrollbarProps.propsDecl,
    force:                          PropTypes.bool,
    id:                             PropTypes.number,
    onChange:                       PropTypes.func,
    onFocus:                        PropTypes.func,
    onBlur:                         PropTypes.func,
    onKeyDown:                      PropTypes.func
};